import { RootState } from 'store/rootTypes';

export const DashboardSelector = (state: RootState) => state.Dashboard;
